export default {
  LatestPayments: 'Latest Payments',
  Plan: 'Plan',
  SMSPlan: 'SMS Plan',
  FuturePlan: 'Future Plan'
};
